function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelector('.menu-drawer__header-close').addEventListener('click',function(){
  if (document.querySelector('#Details-menu-drawer-container').classList.contains('menu-opening')) {
    document.querySelector('#Details-menu-drawer-container').classList.remove('menu-opening');
  }
  if (document.querySelector('#Details-menu-drawer-container').hasAttribute('open')) {
    setTimeout(function(){
      document.querySelector('#Details-menu-drawer-container').removeAttribute('open');
    },400);
  }
  if (document.querySelector('body').classList.contains('overflow-hidden-tablet')) {
    document.querySelector('body').classList.remove('overflow-hidden-tablet');
  }
  document.querySelector('#Details-menu-drawer-container > summary').setAttribute('aria-expanded', false);
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateVariantSKU();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateVariantSKU() {
    console.log(this.currentVariant.id);
    if (document.querySelector('.variant-sku')) {
      document.querySelector('.variant-sku').innerHTML = this.currentVariant.sku;
    }
    if (document.querySelector('.variant-manufacturer-sku') && document.querySelector('.hidden-metafields').querySelector('.variant-id-' + this.currentVariant.id )) {
      document.querySelector('.variant-manufacturer-sku-row').style.display = "table-row";
      document.querySelector('.variant-manufacturer-sku').innerHTML = document.querySelector('.hidden-metafields').querySelector('.variant-id-' + this.currentVariant.id ).innerHTML;
    } else {
      if (document.querySelector('.variant-manufacturer-sku-row')) {
        document.querySelector('.variant-manufacturer-sku-row').style.display = "none";
      }
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

function offset(el) {
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function removeElement(element) {
  element.remove();
}

document.addEventListener( 'DOMContentLoaded', function () {

  if (document.querySelector(".scroll-to-element")) {
    var allLink = document.querySelectorAll('.scroll-to-element');
	var allLinkArr = Array.prototype.slice.call(allLink);
	allLinkArr.forEach(function(link, index){
	  link.addEventListener('click',function(e){
        e.preventDefault();
        var target = link.getAttribute('href');
        var elementPos = offset(document.querySelector(target)).top - 200;
        window.scrollTo({top: elementPos, behavior: 'smooth'});
      }); 
	});
  }

  if (document.querySelector('.accordion__title')) {
    var allAccordions = document.querySelectorAll('.accordion__title');
	var allAccordionsArr = Array.prototype.slice.call(allAccordions);
	allAccordionsArr.forEach(function(accordion, index){
	  accordion.addEventListener('click',function(){
        accordion.closest('.accordion').classList.toggle('open');
      });
	});
  }

  if (document.querySelector('.bubble')){
    var allBubbles = document.querySelectorAll('.bubble');
    var allBubblesArr = Array.prototype.slice.call(allBubbles);
    allBubblesArr.forEach(function(bubble, index){
      var bubble_content = bubble.innerHTML;
      var bubble_content_tag = document.createElement('span');
      bubble_content_tag.classList.add('content');
      bubble_content_tag.innerHTML = bubble_content;
      bubble.innerHTML = "";
      bubble.append(bubble_content_tag);
    });
  }

  if (document.querySelector('.product__description img')) {
    var allImages = document.querySelectorAll('.product__description img');
    var allImagesArr = Array.prototype.slice.call(allImages);
    allImagesArr.forEach(function(img, index){
      if (img.hasAttribute('src')) {
        var img_src = img.getAttribute('src');
        if (img_src.includes('Xero-Parts-Warranty-Web-b_240x240')) {
          img.setAttribute('src','//cdn.shopify.com/s/files/1/0616/1999/4775/files/Xero-Parts-Warranty-Web-b_d8ff9533-efe1-4bf8-aebc-cbce09d28783.jpg?v=1678449921');
        }
        var lowercase_img_src = img_src.toLowerCase();
        if (lowercase_img_src.includes('warranty')) {
          img.classList.add('warranty');
        }
      }
    });
  }

  if (document.querySelector('iframe')) {
    function wrap(el, wrapper) {
      el.parentNode.insertBefore(wrapper, el);
      wrapper.appendChild(el);
    }
    var allIframes = document.querySelectorAll('iframe');
    var allIframesArr = Array.prototype.slice.call(allIframes);
    allIframesArr.forEach(function(iframeHtmlTag, index){
      if (iframeHtmlTag.hasAttribute('src') && iframeHtmlTag.getAttribute('src').includes('youtube')) {
        var videoContainer = document.createElement('div');
        videoContainer.classList.add('video-container');
        if (iframeHtmlTag.getAttribute('width')) {
          var maxWidth = iframeHtmlTag.getAttribute('width');
          if (!maxWidth.includes('%') && !maxWidth.includes('px') && !maxWidth.includes('em') && !maxWidth.includes('rem')) {
            maxWidth += 'px';
          }
          videoContainer.style.maxWidth = maxWidth;
        }
        wrap(iframeHtmlTag, videoContainer);
      }
    });
  }

  if (document.querySelector('.slider-mobile-gutter:not(.thumbnail-slider)')) {
    function productSlidesAdaptiveHeight() {
      var slideWidth = document.querySelector('.slider-mobile-gutter:not(.thumbnail-slider)').offsetWidth;
      var allSlides = document.querySelectorAll('.slider-mobile-gutter:not(.thumbnail-slider) .product__media');
      var allSlidesArr = Array.prototype.slice.call(allSlides);
      allSlidesArr.forEach(function(slide, index){
        if (window.innerWidth >= 750) {
          slide.style.maxHeight = slideWidth + 'px';
          slide.style.height = 'calc(100vh - 296px)';
        } else {
          slide.style.maxHeight = '';
          slide.style.height = '';
        }
      });
    }
    productSlidesAdaptiveHeight();
    window.addEventListener('resize',function(){
      productSlidesAdaptiveHeight();
    });
  }

  if (document.querySelector('.product-video-section')) {
    var allVideos = document.querySelectorAll('.product-video-section__video');
    var allVideosArr = Array.prototype.slice.call(allVideos);
    allVideosArr.forEach(function(video_block, index){
      video_block.querySelector('img').addEventListener('click',function(){
        var video_code = this.getAttribute('data-code');
        var iframe_tag = document.createElement('iframe');
        iframe_tag.setAttribute('src','https://www.youtube.com/embed/'+video_code);
        iframe_tag.setAttribute('title','YouTube video player');
        iframe_tag.setAttribute('frameborder','0');
        iframe_tag.setAttribute('allow','accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
        iframe_tag.setAttribute('allowfullscreen','true');
        video_block.innerHTML = "";
        video_block.append(iframe_tag);
      });
    });
  }

  if (document.querySelector('.fixed-header')) {
    console.log('fixed-header');
    function fixedHeader(){
      var header = document.querySelector('.fixed-header');
      var headerHeight = header.offsetHeight;

      var announcementBarGroup = document.querySelector('#shopify-section-announcement-bar-custom');
      headerHeight += announcementBarGroup.offsetHeight;

      var totalBarsHeight = 0;
      var totalFixedBarsHeight = 0;
      var allBars = document.querySelectorAll('.announcement-bar');
      
      var allBarsArr = Array.prototype.slice.call(allBars);
      allBarsArr.forEach(function(el, index){
        totalBarsHeight += el.offsetHeight;
        if (el.classList.contains('announcement-bar--fixed')) {
          totalFixedBarsHeight += el.offsetHeight;
        }
      });

      var windowPos = window.pageYOffset || document.documentElement.scrollTop;

      header.style.position = 'fixed';
      header.style.width = '100vw';
      document.querySelector('main').style.marginTop = headerHeight+'px';
      var headerTop = totalFixedBarsHeight + (totalBarsHeight - totalFixedBarsHeight - windowPos);
      if (totalBarsHeight - totalFixedBarsHeight - windowPos < 0) {
        headerTop = totalFixedBarsHeight;
      }
      header.style.top = headerTop + 'px';
    }
    fixedHeader();
    window.addEventListener('scroll', function(){
      fixedHeader();
    });
  }

  if(document.querySelector('.header__icon--help')){
    document.querySelector('.header__icon--help').addEventListener('click', function(e) {
      if (window.innerWidth < 500) {
        document.querySelector('.header__icon--help').classList.toggle('open');
      }
    });
  }

  // Sticky sidebar filter
  if (document.querySelector('body .ais-page .ais-block')) {
    function stickyFilter(scrollToTop) {
      if (window.innerWidth >= 800) {
        var rect = document.querySelector('body .ais-page .ais-block').getBoundingClientRect();
        var parentHeight = document.querySelector('body .ais-page').offsetHeight - 100;
        var filterWidth = document.querySelector('body .ais-page .ais-facets').offsetWidth;
        var filterHeight = document.querySelector('body .ais-page .ais-facets-inner').offsetHeight;
        var announcementBarHeight = 0;
        var allBars = document.querySelectorAll('.announcement-bar--fixed');
        var allBarsArr = Array.prototype.slice.call(allBars);
        allBarsArr.forEach(function(bar, index){
            announcementBarHeight += bar.offsetHeight;
        });
        var headerHeight = document.querySelector('.fixed-header').offsetHeight;
        var filterTopPos = announcementBarHeight + headerHeight;
        if (scrollToTop) {
          var headerHeight = document.querySelector('.header-wrapper').offsetHeight;
          filterTopPos = announcementBarHeight + headerHeight;
        }
        if (parentHeight > filterHeight) {
          if (rect.top < filterTopPos) {
            if (!document.querySelector('.ais-facets-inner').classList.contains('fixed')) {
              document.querySelector('.ais-facets-inner').classList.add('fixed');
              document.querySelector('.ais-facets-inner').style.width = filterWidth + 'px'
            }
            document.querySelector('.ais-facets-inner').style.top = filterTopPos + 'px';
            if (rect.top + parentHeight - filterHeight - filterTopPos <= 0) {
              if (document.querySelector('.ais-facets-inner').classList.contains('fixed')) {
                document.querySelector('.ais-facets-inner').classList.remove('fixed');
              }
              document.querySelector('.ais-facets').style.marginTop = parseInt(parentHeight - filterHeight) + 'px';
            } else {
              document.querySelector('.ais-facets').style.marginTop = '10px';
            }
          } else {
            if (document.querySelector('.ais-facets-inner').classList.contains('fixed')) {
              document.querySelector('.ais-facets-inner').classList.remove('fixed');
              document.querySelector('.ais-facets-inner').removeAttribute('style');
            }
          }
        }
      } else {
        document.querySelector('.ais-facets').style.marginTop = '10px';
      }
    }
    
    var scrollToTop = false;
    stickyFilter(scrollToTop);
    var lastScrollTop = 0;

    window.addEventListener('click', function(e){
      if (e.target.classList.contains('ais-Pagination-link') && window.innerWidth >= 800){
        document.querySelector('.ais-facets').style.marginTop = '10px';
      }
    });
    
    window.addEventListener('scroll', function(){
      var st = window.pageYOffset || document.documentElement.scrollTop;
      if (st > lastScrollTop){
        scrollToTop = false;
      } else {
        scrollToTop = true;
      }
      lastScrollTop = st <= 0 ? 0 : st;
      stickyFilter(scrollToTop);
    });
  }

  // Hide product type facets from filter
  if (document.querySelector('.ais-facet-product_type')) {
    var productTypeFacets = document.querySelector('.ais-facet-product_type');
    if(window.addEventListener) {
      // Normal browsers
      productTypeFacets.addEventListener('DOMSubtreeModified', productTypeFacetsChanged, false);
    } else if(window.attachEvent) {
      // IE
      productTypeFacets.attachEvent('DOMSubtreeModified', productTypeFacetsChanged);
    }
    async function productTypeFacetsChanged() {
      if (document.querySelector('.ais-facet-product_type .label-text')) {
        var allFacets = document.querySelectorAll('.ais-facet-product_type .label-text');
        var allFacetsArr = Array.prototype.slice.call(allFacets);
        allFacetsArr.forEach(function(el, index){
            if (el.innerHTML == 'OS' || el.innerHTML == 'Hidden - No Shipping Status Notification') {
              var elNumber = index + 1;
              document.querySelector('.ais-facet-product_type .ais-facet--item:nth-child(' + elNumber + ')').style.display = 'none';
            }
        });
      }
    }
  }

  if (document.querySelector('.ais-block') && window.innerWidth >= 800) {
    var productList = document.querySelector('.ais-block');
    if(window.addEventListener) {
      // Normal browsers
      productList.addEventListener('DOMSubtreeModified', productListChanged, false);
    } else if(window.attachEvent) {
      // IE
      productList.attachEvent('DOMSubtreeModified', productListChanged);
    }
    async function productListChanged() {
      var parentHeight = document.querySelector('body .ais-page').offsetHeight - 100;
      var filterHeight = document.querySelector('body .ais-page .ais-facets-inner').offsetHeight;
      if (parentHeight <= filterHeight) {
        if (document.querySelector('.ais-facets-inner.fixed')) {
          document.querySelector('.ais-facets-inner.fixed').classList.remove('fixed');
        }
      }
    }
  }

  if (document.querySelector('.my-account-mobile-menu-btn')) {
    document.querySelector('.my-account-mobile-menu-btn').addEventListener('click', function(){
      if (document.querySelector('.account-sidebar')) {
        document.querySelector('.account-sidebar').classList.toggle('opened');
      }
    });
  }

  function addTableContainer(table_selector) {
    if (document.querySelector(table_selector)) {
      var allTabls = document.querySelectorAll(table_selector);
      var allTablsArr = Array.prototype.slice.call(allTabls);
      allTablsArr.forEach(function(current_table, index){
        var temp_elem = document.createElement('div');
        temp_elem.classList.add('table-temp');
        current_table.after(temp_elem);
  
        var table_container = document.createElement('div');
        table_container.classList.add('table-container');
        table_container.append(current_table);
        document.querySelector('.table-temp').after(table_container);
        document.querySelector('.table-temp').remove();
      });
    }
  }
  addTableContainer('.product__description table');
  addTableContainer('.rich-text table');

  if ( document.querySelector('.product-form__submit[name="add"]') ) {
    var addToCartButton = document.querySelector('.product-form__submit[name="add"]');
    addToCartButton.addEventListener('click', function(e) {
      console.log('!!!');
    });
  }
  function stickyBar(){
    if (document.querySelectorAll('.announcement-bar--fixed').length > 0) {
      var fixed_bars_total_height = 0;
      var allFixedBars = document.querySelectorAll('.announcement-bar--fixed');
      var allFixedBarsArr = Array.prototype.slice.call(allFixedBars);
      allFixedBarsArr.forEach(function(bar, index){
        var current_bar_height = bar.offsetHeight;
        bar.style.top = fixed_bars_total_height + 'px';
        fixed_bars_total_height += current_bar_height;
        bar.style.position = 'fixed';
      });
      document.querySelector('#shopify-section-announcement-bar-custom').style.paddingTop = fixed_bars_total_height + 'px';
      document.querySelector('#shopify-section-header').style.top = fixed_bars_total_height + 'px';
    }
  }
  stickyBar();
  window.addEventListener('resize',function(){
    stickyBar();
  });

  // InstaFeed slider dots
  if (document.querySelector('#insta-feed')) {
    document.querySelector('#insta-feed').addEventListener('DOMSubtreeModified',function(){
      if(document.querySelectorAll('#insta-feed .slide-page').length != 0 && document.querySelectorAll('.insta-feed-dots').length == 0) {
        var page_counter = 0;
        var allSlides = document.querySelectorAll('#insta-feed .slide-page');
        var allSlidesArr = Array.prototype.slice.call(allSlides);
        allSlidesArr.forEach(function(el, index){
          if (parseInt(el.getAttribute('data-slide-page')) > page_counter) {
            page_counter = parseInt(el.getAttribute('data-slide-page'));
          }
        });
        var dots = document.createElement('div');
        dots.classList.add('insta-feed-dots');
        for (var i = 1; i <= page_counter; i++) {
          var dot = document.createElement('div');
          dot.classList.add('insta-feed-dot');
          if (i == 1) {
            dot.classList.add('active');
          }
          dot.setAttribute('insta-feed__page-anchor', i);
          dots.append(dot);
        }
        document.querySelector('#insta-feed').append(dots);

        // Dots actions
        var allDots = document.querySelectorAll('.insta-feed-dot');
        var allDotsArr = Array.prototype.slice.call(allDots);
        allDotsArr.forEach(function(dot_btn, index){
          dot_btn.addEventListener('click',function(e){
            if (!dot_btn.classList.contains('active')) {
              var page_for_show = parseInt(dot_btn.getAttribute('insta-feed__page-anchor'));
              document.querySelector('.insta-feed-dot.active').classList.remove('active');
              dot_btn.classList.add('active');
              allSlidesArr.forEach(function(el, index){
                if (parseInt(el.getAttribute('data-slide-page')) != page_for_show) {
                  el.style.display = 'none';
                } else {
                  el.style.display = 'initial';
                }
              });
            }
          });
        });
      }
    });
  }
});
 $(window).scroll(function(){
  if ($(window).scrollTop() >= 100) {
        $('.header-wrapper').addClass('main-fixed-header');
    }
    else {
        $('.header-wrapper').removeClass('main-fixed-header');
    }
});